module.exports = __webpack_public_path__ + "static/media/mob16.d04f0a8d.jpeg";